import { createEventEmitter } from "@/events";
import type { TokenId } from "../types/token.types";
import { EVENT_SUFFIXES } from "../types/event.types";
import type { TransactionHash } from "../types/transaction.types";
import { TRANSACTION_TYPES } from "../types/transaction.constants";

export const LOCK_EVENTS = {
    SUCCESS: `${TRANSACTION_TYPES.LOCK}:${EVENT_SUFFIXES.SUCCESS}`,
    MORE: `${TRANSACTION_TYPES.LOCK}:${EVENT_SUFFIXES.MORE}`,
    WITHDRAW: `${TRANSACTION_TYPES.LOCK}:${EVENT_SUFFIXES.WITHDRAW}`,
} as const;

export interface LockSuccessPayload {
    transactionHash: TransactionHash;
    lockTokenId: TokenId;
    lockAmount: number;
}

export interface LockMoreTransactionDialogProps {
    lockPositionId: number;
    amount: number;
}

export interface LockWithdrawPayload {
    transactionHash: TransactionHash;
    withdrawAmount: number;
    lockDuration: number;
}

export interface LockWithdrawPayload {
    transactionHash: TransactionHash;
    lockDuration: number;
}

export interface LockEventPayloads extends Record<string, unknown> {
    [LOCK_EVENTS.SUCCESS]: LockSuccessPayload;
    [LOCK_EVENTS.MORE]: LockMoreTransactionDialogProps;
    [LOCK_EVENTS.WITHDRAW]: LockWithdrawPayload;
}

export const lockEventEmitter = createEventEmitter<LockEventPayloads>();
